
<div *ngIf="imageQrData">
    <p-image [src]="imageQrData" [preview]="true" [width]="width" [height]="height"></p-image>
</div>
<div *ngIf="!imageQrData">
    <p-image [width]="width" [height]="height"></p-image>
</div>
